import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import { App } from './App';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#167a5b',
          colorInfo: '#2f6fb3',
          colorSuccess: '#167a5b',
          colorWarning: '#b46a16',
          colorError: '#b33a3a',
          borderRadius: 6,
          fontFamily:
            "Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', sans-serif",
        },
        components: {
          Layout: { siderBg: '#17231f', headerBg: '#ffffff', bodyBg: '#f3f5f4' },
          Menu: { darkItemBg: '#17231f', darkItemSelectedBg: '#285b49' },
          Card: { headerHeight: 44 },
          Table: { headerBg: '#f6f8f7', headerColor: '#40504a' },
        },
      }}
    >
      <AntApp>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
